import { CustomsTaxService } from "./CustomsTaxService";

import { CustomsTaxServiceInterface } from "./interface";

export const customsTaxService: { (): CustomsTaxServiceInterface } = () => new CustomsTaxService();